// extracted by mini-css-extract-plugin
module.exports = {"videoContenaire":"ModalVideo_videoContenaire__CwfxQ","btnClose":"ModalVideo_btnClose__XSOe9"};